function handleGetSet(formField, commitName) {
  return {
    get() {
      return this[formField+'Val'];
    },
    set(value) {
      this[commitName](value);
    }
  }
}

function dynamicForm(fields) {
  let objs = {};
  for (let [key, value] of Object.entries(fields)) {
    objs[key] = handleGetSet(key, value);
  }

  return objs;
}

export const mapStateInfo = [
  'form',
  'info',
  'settings',
  'tripType',
  'toPlace',
  'fromPlace',
  'hasSetting',
  'phoneData'
];

export const mapStateInfoVal = {
  firstNameVal: state => state.form.clientFirstName,
  arrivalFligthNumberVal: state => state.form.arrivalFlightNumber,
  arrivalAirlineVal: state => state.form.arrivalAirline,
  lastNameVal: state => state.form.clientLastName,
  emailVal: state => state.form.clientEmail,
  phoneVal: state => state.form.clientPhone,
  notesVal: state => state.form.clientNotes,
  departureFlightNumberVal: state => state.form.departureFlightNumber,
  departureAirlineVal: state => state.form.departureAirline,
  originPickUpTimeVal: state => state.form.originPickUpTime,
  pickUpTimeVal: state => state.form.pickUpTime,
  destinationPickUpTimeVal: state => state.form.destinationPickUpTime,
  paymentMethodVal: state => state.form.paymentMethod,

  arrivalDateVal: state => state.formDates.arrivalDate,
  arrivalHoursVal: state => state.formDates.arrivalHours,
  arrivalMinutesVal: state => state.formDates.arrivalMinutes,
  departureDateVal: state => state.formDates.departureDate,
  departureMinutesVal: state => state.formDates.departureMinutes,
  departureHoursVal: state => state.formDates.departureHours,
  originDateVal: state => state.formDates.originDate,
  originHoursVal: state => state.formDates.originHours,
  originMinutesVal: state => state.formDates.originMinutes,
  destinationDateVal: state => state.formDates.destinationDate,
  destinationHoursVal: state => state.formDates.destinationHours,
  destinationMinutesVal: state => state.formDates.destinationMinutes,

  pickUpDateVal: state => state.formDates.pickUpDate,
  pickUpHoursVal: state => state.formDates.pickUpHours,
  pickUpMinutesVal: state => state.formDates.pickUpMinutes,
};

export const mapMutationsInfo = [
  'formFirstName',
  'formLastName',
  'formEmail',
  'formPhone',
  'formNotes',
  'formArrivalFligthNumber',
  'formArrivalAirline',
  'formArrivalFlightTime',
  'formDepartureFligthNumber',
  'formDepartureAirline',
  'formDepartureFlightTime',
  'formOriginPickupTime',
  'formDestinationPickUpTime',
  'formPickUpTime',
  'formPaymentMethod',
  'voucherToken',
  'formDatesArrivalDate',
  'formDatesArrivalHours',
  'formDatesArrivalMinutes',
  'formDatesDepartureDate',
  'formDatesDepartureMinutes',
  'formDatesDepartureHours',
  'formDatesOriginDate',
  'formDatesOriginHours',
  'formDatesOriginMinutes',
  'formDatesDestinationDate',
  'formDatesDestinationHours',
  'formDatesDestinationMinutes',
  'formDatesPickUpDate',
  'formDatesPickUpHours',
  'formDatesPickUpMinutes'
];

export const dynamicFormSetGet = () => {
  return dynamicForm({
      firstName: 'formFirstName',
      arrivalFligthNumber: 'formArrivalFligthNumber',
      arrivalAirline: 'formArrivalAirline',
      lastName: 'formLastName',
      email: 'formEmail',
      phone: 'formPhone',
      notes: 'formNotes',
      paymentMethod: 'formPaymentMethod',
      departureFlightNumber: 'formDepartureFligthNumber',
      departureAirline: 'formDepartureAirline',
      originPickUpTime: 'formOriginPickupTime',
      destinationPickUpTime: 'formDestinationPickUpTime',
      pickUpTime: 'formPickUpTime',

      arrivalDate:      'formDatesArrivalDate',
      arrivalHours:     'formDatesArrivalHours',
      arrivalMinutes:   'formDatesArrivalMinutes',
      departureDate:    'formDatesDepartureDate',
      departureMinutes: 'formDatesDepartureMinutes',
      departureHours:   'formDatesDepartureHours',
      originDate:       'formDatesOriginDate',
      originHours:       'formDatesOriginHours',
      originMinutes:     'formDatesOriginMinutes',
      destinationDate:   'formDatesDestinationDate',
      destinationHours:  'formDatesDestinationHours',
      destinationMinutes:  'formDatesDestinationMinutes',

      pickUpDate:   'formDatesPickUpDate',
      pickUpHours:  'formDatesPickUpHours',
      pickUpMinutes:  'formDatesPickUpMinutes',
    });
};
